(() => {
  'use strict';
  // Un seul point d'entrée PDP; ne s'exécute pas sur le reste du thème.
  window.vlmPdpMaster = true;
  const one = (selector, scope = document) => scope.querySelector(selector);
  const many = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: window.vlmShop?.currency || 'EUR' });
  const price = value => fmt.format((Number(value) || 0) / 100);
  const qtyNumber = input => Math.max(1, Math.min(99, parseInt(input?.value || '1', 10) || 1));
  const ajaxRoot = (window.vlmRoutes?.root || '/').replace(/\/?$/, '/');
  const ajaxAddUrl = ajaxRoot + 'cart/add.js';

  function initCoverage() {
    const section = one('[data-vlm-coverage]');
    const form = one('.vlm-product-form');
    if (!section || !form) return;
    const area = one('[data-vlm-area]', section);
    const waste = one('[data-vlm-waste]', section);
    const output = one('[data-vlm-result]', section);
    const apply = one('[data-vlm-apply-qty]', section);
    const rollSize = Number(section.dataset.rollM2);
    let result = 0;
    if (!rollSize || rollSize <= 0) return;
    const update = () => {
      const m2 = Number(String(area.value).replace(',', '.'));
      if (!Number.isFinite(m2) || m2 < 0.5 || m2 > 400) {
        output.textContent = 'Indiquez une surface entre 0,5 et 400 m².';
        apply.disabled = true;
        result = 0;
        return;
      }
      result = Math.ceil(m2 * (1 + Number(waste.value) / 100) / rollSize);
      output.textContent = String(result) + ' rouleau' + (result > 1 ? 'x' : '') +
        ' de ' + String(rollSize).replace('.', ',') + ' m², avec ' + waste.value + ' % de pertes.';
      apply.disabled = false;
    };
    area.addEventListener('input', update);
    waste.addEventListener('change', update);
    apply.addEventListener('click', () => {
      if (result < 1) return;
      const input = one('[name="quantity"]', form);
      if (input) {
        input.value = result;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      apply.textContent = 'Quantité appliquée ✓';
      setTimeout(() => { apply.textContent = 'Appliquer cette quantité'; }, 1800);
    });
  }

  function getVariant(form) {
    if (!form) return null;
    const picker = one('select[name="id"]', form);
    const input = one('input[name="id"]', form);
    const id = picker?.value || input?.value;
    const option = picker?.selectedOptions?.[0];
    const amount = Number(option?.dataset?.price ?? form.dataset.vlmMainPrice);
    const available = option ? option.dataset.available === 'true' : !one('.vlm-buy', form)?.disabled;
    return (id && Number.isFinite(amount)) ? { id: Number(id), price: amount, available } : null;
  }

  function initStockAndMobile() {
    const bar = one('[data-vlm-mobile-atc]');
    const button = bar && one('[data-vlm-scroll-buy]', bar);
    const form = one('.vlm-product-form');
    const install = one('#pose-vlm');
    const stock = one('[data-vlm-stock]');
    const picker = form && one('select[name="id"]', form);
    const action = bar && one('[data-vlm-mobile-action]', bar);
    const mobilePrice = bar && one('[data-vlm-mobile-price]', bar);
    if (!bar || !button) return;

    const update = () => {
      if (!form) return;
      const current = getVariant(form);
      if (current && mobilePrice) mobilePrice.textContent = price(current.price);
      button.disabled = !current?.available;
      if (action) action.textContent = !current?.available ? 'INDISPONIBLE' : (picker ? 'OPTIONS' : 'AJOUTER');
      if (stock && picker) {
        const opt = picker.selectedOptions?.[0];
        const available = Boolean(current?.available);
        const dot = document.createElement('span');
        dot.className = 'vlm-pdp-stock__dot ' + (available ? 'is-unknown' : 'is-out');
        stock.hidden = available;
        stock.replaceChildren(...(available ? [] : [dot, document.createTextNode(' Indisponible')]));
      }
    };
    picker?.addEventListener('change', update);
    if (form) update();

    const anchor = form || install;
    if (!anchor) return;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => bar.classList.toggle('is-visible', !entry.isIntersecting));
      }, { threshold: .1 });
      observer.observe(anchor);
    }
    button.addEventListener('click', () => {
      if (!form) {
        if (install) {
          install.open = true;
          install.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      if (picker) {
        const visual = one('[data-vlm-visual-choices]', form);
        (visual || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (visual) one('button:not(:disabled),select:not(:disabled)', visual)?.focus({ preventScroll: true });
        else picker.focus({ preventScroll: true });
      } else if (getVariant(form)?.available) {
        const submit = one('button[type="submit"]', form);
        if (submit && !submit.disabled) form.requestSubmit(submit);
      }
    });
  }

  function initBundle() {
    const bundle = one('[data-vlm-bundle]');
    const form = one('.vlm-product-form');
    const bundleForm = bundle && one('[data-vlm-bundle-form]', bundle);
    if (!bundleForm || !form) return;
    const total = one('[data-vlm-bundle-total]', bundle);
    const error = one('[data-vlm-bundle-error]', bundle);
    const submit = one('[data-vlm-bundle-submit]', bundle);
    const lines = many('[data-vlm-bundle-line]', bundle);
    const mainQty = one('[name="quantity"]', form);
    const mainSelect = one('select[name="id"]', form);
    let busy = false;
    const showError = message => {
      error.hidden = !message;
      error.textContent = message || '';
    };
    const getAccessory = line => {
      const selected = one('[data-vlm-bundle-check]', line)?.checked;
      if (!selected) return null;
      const field = one('[data-vlm-bundle-variant]', line);
      const option = field?.tagName === 'SELECT' ? field.selectedOptions?.[0] : null;
      const variantId = Number(field?.value);
      const amount = Number(option?.dataset.price ?? field?.dataset.price);
      const q = qtyNumber(one('[data-vlm-bundle-qty]', line));
      if (!variantId || !Number.isFinite(amount) || amount < 0) {
        throw new Error('Sélectionnez une version pour chaque accessoire coché.');
      }
      return { id: variantId, quantity: q, price: amount };
    };
    const compute = () => {
      const v = getVariant(form);
      if (!v?.available) {
        total.textContent = 'Indisponible';
        submit.disabled = true;
        return null;
      }
      const cartItems = [{ id: v.id, quantity: qtyNumber(mainQty), price: v.price }];
      try {
        lines.forEach(line => {
          const accessory = getAccessory(line);
          if (accessory) cartItems.push(accessory);
        });
      } catch (err) {
        total.textContent = 'Choisir les options';
        submit.disabled = true;
        return null;
      }
      total.textContent = price(cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0));
      submit.disabled = busy;
      return cartItems;
    };
    many('input,select', bundleForm).forEach(field => {
      field.addEventListener('input', () => { showError(''); compute(); });
      field.addEventListener('change', () => { showError(''); compute(); });
    });
    mainSelect?.addEventListener('change', compute);
    mainQty?.addEventListener('input', compute);
    mainQty?.addEventListener('change', compute);
    many('[data-vlm-qty-plus],[data-vlm-qty-minus]', form).forEach(button => button.addEventListener('click', compute));
    compute();
    bundleForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const items = compute();
      if (!items) {
        showError('Vérifiez les variantes et la disponibilité de votre sélection.');
        return;
      }
      busy = true;
      submit.disabled = true;
      const former = submit.textContent;
      submit.textContent = 'AJOUT EN COURS…';
      showError('');
      try {
        const response = await fetch(ajaxAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items.map(({id,quantity}) => ({id,quantity})) })
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Vérifiez les disponibilités.');
        }
        const cartTrigger = one('[data-vlm-cart-open]');
        if (cartTrigger) cartTrigger.click();
        else window.location.href = ajaxRoot + 'cart';
      } catch (err) {
        showError('Ajout impossible : ' + (err.message || 'réessayez après avoir vérifié les stocks.'));
      } finally {
        busy = false;
        submit.textContent = former;
        compute();
      }
    });
  }

  function initPhotoZoom() {
    // Zoom natif seulement sur les images source présentes, sans produire de photo artificielle.
    many('.vlm-product-media img').forEach(img => {
      if (!img.currentSrc && !img.src) return;
      img.classList.add('vlm-pdp-image-zoom');
      img.addEventListener('click', () => {
        const src = img.currentSrc || img.src;
        const overlay = document.createElement('dialog');
        overlay.className = 'vlm-pdp-lightbox';
        const figure = document.createElement('figure');
        const full = document.createElement('img');
        full.src = src;
        full.alt = img.alt || '';
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'vlm-pdp-lightbox__close';
        close.textContent = 'Fermer ×';
        close.addEventListener('click', () => overlay.close());
        figure.appendChild(full);
        overlay.appendChild(close);
        overlay.appendChild(figure);
        overlay.addEventListener('close', () => overlay.remove(), { once: true });
        overlay.addEventListener('click', event => { if (event.target === overlay) overlay.close(); });
        document.body.appendChild(overlay);
        overlay.showModal();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCoverage();
    initStockAndMobile();
    initBundle();
    initPhotoZoom();
  });
})();